<template>
  <div class="revenbook">
    <div class="revenbook-tabs vue_flex vue_flex_between vue_align_center">
      <ul class="revenbook-tabs-boxs vue_flex">
        <li class="vue_relative h" :class="activeName === tabs.activeVal? 'active' : 'activenot'" v-for="(tabs, tabsIndex) in tabsList" :key="tabsIndex" @click="handleClick(tabs)">
          <p class="vue-font-PingFang-bold">{{tabs.title}}</p>
          <div class="vue_absolute" v-if="activeName === tabs.activeVal"></div>
        </li>
      </ul>
      <div class="revenbook-tabs-but vue-font-PingFang-500 h" @click="strokeDrawer = true">记一笔</div>
    </div>

    <div class="revenbook-screen vue_flex">
      <template v-if="activeName !== 'keep'">
        <!-- <div class="shaixuan_item" v-if="activeName !== 'calendar'">
          <div class="shaixuan_item_con">
            <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt=""/>
            <div class="shaixuan_item_tit">统计时间</div>
          </div>
          <el-date-picker v-model="value1" type="date" placeholder="选择日期" class="vue_flex_item"></el-date-picker>
        </div> -->
        <div class="shaixuan_item">
          <div class="shaixuan_item_con">
            <div class="shaixuan_item_tit">平台/店铺</div>
          </div>
          <el-select v-model="listQuery.shopid" placeholder="请选择" class="vue_flex_item" @change="choose">
            <el-option v-for="item in dpList" :key="item.shopid" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </template>
      <template v-if="activeName === 'keep'">
        <div class="top_bar_inp vue_flex vue_align_center">
          <img class="top_bar_inp_img1 h" src="../../../../../assets/yimou/ss.png" alt="" />
          <input type="text" class="top_bar_inp_inp" v-model="listQuery.name" placeholder="模板名称关键字搜索" @input="choose"/>
        </div>
      </template>
    </div>

    <div class="width_100" v-if="activeName === 'census'">
      <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="60vh" :key="'censusTable'">
        <el-table-column prop="feiyongbianma" label="费用编码" align="center"></el-table-column>
        <el-table-column prop="yijileimu" label="一级科目汇总" align="center"></el-table-column>
        <el-table-column prop="erjileimu" label="二级科目汇总" align="center"></el-table-column>
        <!-- <el-table-column prop="sanjileimu" label="三级科目汇总" align="center" ></el-table-column> -->
        <el-table-column prop="feiyongxiang" label="费用项" align="center" ></el-table-column>
        <el-table-column prop="date" label="费用日期" align="center" ></el-table-column>
        <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width" >
          <template slot-scope="row">
            <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="width_100" v-if="activeName === 'calendar'">
      <div class="date-list-app">
        <div class="calendar-section">
          <div class="calendar-header vue_flex vue_flex_around">
            <el-date-picker v-model="currentDate" type="month" placeholder="选择日期" @change="currentChange"></el-date-picker>
            <el-button type="primary" size="small" @click="currentmoon">当前月份</el-button>
          </div>
          <div class="week-days">
            <div v-for="day in ['日', '一', '二', '三', '四', '五', '六']" :key="day">{{ day }}</div>
          </div>
          <div class="date-grid">
            <div v-for="(date, index) in monthDates" :key="index" class="date-cell" :class="{ 'other-month': date.month !== currentMonth, 'has-data': hasData(date), 'today': isToday(date) }" @click="selectDate(date)">
              <span class="date-number">{{ date.day }}</span>
            </div>
          </div>
        </div>

        <!-- 数据列表区域 -->
        <div class="data-section">
          <h3 v-if="selectedDate"> {{ selectedDate.year }}年{{ selectedDate.month }}月{{ selectedDate.day }}日 数据</h3>
          <div v-if="selectedDate && dateList[formatDate(selectedDate)].length">
            <el-table :data="dateList[formatDate(selectedDate)]" style="width: 100%">
              <el-table-column prop="jine" label="金额">
                <template slot-scope="scope">
                  <span :class="Number(scope.row.zhichutype) === 1? 'timeshoutype' : 'timezhitype'">{{ Number(scope.row.zhichutype) === 1? '支出' : '收入' }} {{scope.row.jine}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="yijileimu" label="一级科目汇总"></el-table-column>
              <el-table-column prop="erjileimu" label="二级科目汇总"></el-table-column>
              <el-table-column prop="sanjileimu" label="三级科目汇总"></el-table-column>
            </el-table>
          </div>
          <p v-else>
            {{ selectedDate ? '当日无数据' : '请点击日历日期查看数据' }}
          </p>
        </div>
      </div>

    </div>
    <div class="width_100" v-if="activeName === 'details'">
      <div class="revenbook-details vue_flex vue-font-PingFang-500">
        <span class="color_35">收入</span>
        <span>{{allshouru}}</span>
        <span class="color_35">支出</span>
        <span>{{allzhichu}}</span>
      </div>
      <el-table 
        :data="dataList" 
        tooltip-effect="dark" 
        style="width: 100%" 
        :header-cell-style="headercellstyle" 
        border 
        height="56vh" 
        :key="'detailsTable'"
      >
        <!-- 删掉了 type="selection" 的多选列 -->
        <el-table-column prop="jine" label="金额" align="center">
          <template slot-scope="scope" >
            <span :style="{'color': scope.$index % 2 === 0? 'rgba(5, 193, 0, 1)' : 'rgba(255, 0, 0, 1)' }">{{scope.row.jine }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="feiyongxiang" label="费用项" align="center"></el-table-column>
        <el-table-column prop="" label="科目" align="center"></el-table-column>
        <el-table-column prop="desc" label="备注" align="center"></el-table-column>
      </el-table>
    </div>

    <div class="width_100" v-if="activeName === 'keep'">
      <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh" :key="'keepTable'">
        <!-- <el-table-column prop="mobanname" label="模板名称" align="center"></el-table-column> -->
        <el-table-column prop="yijileimu" label="一级科目汇总" align="center"></el-table-column>
        <el-table-column prop="erjileimu" label="二级科目汇总" align="center"></el-table-column>
        <el-table-column prop="feiyongxiang" label="费用项" align="center" ></el-table-column>
        <el-table-column prop="createtime" label="创建日期" align="center" ></el-table-column>
        <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width" >
          <template slot-scope="row">
            <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getHetongListFun"/>


    <el-drawer title="记一笔" :visible.sync="strokeDrawer" :show-close="true" size="34%">
      <div ref="scrollContainer" style="max-height: 88vh; overflow-y: auto;">
        <div class="revenbook-drawer vue_flex vue_column">
          <el-radio-group v-model="tempObj.radio">
            <el-radio label="0">普通记账</el-radio>
            <el-radio label="1">模版记账</el-radio>
          </el-radio-group>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500"> <span>*</span> <p> 费用编码 </p> </li>
            <li class="revenbook-drawer-ul-boxs">
              <el-input v-model="tempObj.feiyongbianma" placeholder="请输入费用编码" class="vue-font-PingFang-500"></el-input>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 一级科目 </p>
            </li>
            <li class="revenbook-drawer-ul-boxs">
              <el-input v-model="tempObj.yijileimu" placeholder="请输入一级类目" class="vue-font-PingFang-500"></el-input>
              <!-- <el-select v-model="tempObj.yijileimu" placeholder="请选择">
                <el-option v-for="item in dataList" :key="item.yijileimu" :label="item.yijileimu" :value="item.yijileimu"></el-option>
              </el-select> -->
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 二级科目 </p>
            </li>
            <li class="revenbook-drawer-ul-boxs">
              <el-input v-model="tempObj.erjileimu" placeholder="请输入二级类目" class="vue-font-PingFang-500"></el-input>
              <!-- <el-select v-model="tempObj.erjileimu" placeholder="请选择">
                <el-option v-for="item in dataList" :key="item.erjileimu" :label="item.erjileimu" :value="item.erjileimu"></el-option>
              </el-select> -->
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 费用项 </p>
            </li>
            <li class="revenbook-drawer-ul-boxs">
              <el-input v-model="tempObj.feiyongxiang" placeholder="请输入费用项" class="vue-font-PingFang-500"></el-input>
              <!-- <el-select v-model="tempObj.feiyongxiang" placeholder="请选择">
                <el-option v-for="item in dataList" :key="item.feiyongxiang" :label="item.feiyongxiang" :value="item.feiyongxiang"></el-option>
              </el-select> -->
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 日期 </p>
            </li>
            <li class="revenbook-drawer-ul-radio">
              <el-radio-group v-model="tempObj.isdanri" @change="isdanriChange">
                <el-radio label="1">单日</el-radio>
                <el-radio label="2">均摊到时间范围</el-radio>
              </el-radio-group>
            </li>
            <li class="revenbook-drawer-ul-boxs" v-if="Number(tempObj.isdanri) === 1">
              <el-date-picker v-model="tempObj.date" type="date" placeholder="请选择日期"></el-date-picker>
            </li>
            <li class="revenbook-drawer-ul-boxs" v-if="Number(tempObj.isdanri) === 2">
              <el-date-picker v-model="tempObj.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 金额 </p>
            </li>
            <li class="revenbook-drawer-ul-radio vue_flex vue_align_center">
              <el-radio-group v-model="tempObj.zhichutype">
                <el-radio label="1">支出</el-radio>
                <el-radio label="2">收入</el-radio>
              </el-radio-group>
              <div class="vue_flex_item" v-if="tempObj.zhichutype === '1'" style="padding: 10px 16px; background: rgba(245, 245, 245, 1); border-radius: 10px;  margin-left: 10px">
                <el-radio-group v-model="tempObj.incomeradio">
                  <el-radio label="0"> 填写总金额，均摊到每天</el-radio>
                  <el-radio label="1">填写单日金额，复制到每天</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="revenbook-drawer-ul-boxs">
              <el-input v-model="tempObj.jine" placeholder="例如:100" class="vue-font-PingFang-500"></el-input>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <p> 备注 </p>
            </li>
            <li class="revenbook-drawer-ul-boxs">
              <el-input v-model="tempObj.desc" placeholder="非必填" class="vue-font-PingFang-500"></el-input>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <p> 分摊到店铺 </p>
            </li>
            <li class="revenbook-drawer-ul-radio vue_flex vue_align_center">
              <el-radio-group v-model="tempObj.shopradio">
                <el-radio label="0">全部店铺</el-radio>
                <el-radio label="1">指定店铺</el-radio>
              </el-radio-group>
            </li>
            <template v-if="tempObj.shopradio === '1'">
              <li class="revenbook-drawer-ul-boxs vue_flex vue_flex_around">
                <div class="vue_flex vue_align_center" @click="dialogVisible = true">
                  <img src="../../../../../assets/yimou/jh.png" alt="">
                  <p class="vue-font-PingFang-500">添加店铺</p>
                </div>
              </li>
              <li class="revenbook-drawer-ul-u-tr vue_flex">
                <p class="vue-font-PingFang-bold color_35">平台</p>
                <p class="vue-font-PingFang-bold color_35">店铺名称</p>
              </li>
              <li class="revenbook-drawer-ul-u-th vue_flex" v-for="(shop, shopIndex) in tempObj.shopids" :key="shopIndex">
                <p class="vue-font-PingFang-500 color_35">{{shop.type}}{{Number(shop.type) === 1? '淘宝' : Number(shop.type) === 2? '京东' : '拼多多'}}</p>
                <p class="vue-font-PingFang-500 color_35">{{shop.name}}</p>
              </li>
            </template>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <p> 保存为模版 </p>
            </li>
            <li class="revenbook-drawer-ul-radio vue_flex vue_align_center">
              <el-switch v-model="tempObj.sterplate" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column" v-if="tempObj.sterplate">
            <li class="revenbook-drawer-ul-radio vue_flex vue_align_center">
              <el-select v-model="tempObj.mobanname" placeholder="请选择">
                <el-option v-for="item in dataList" :key="item.feiyongxiang" :label="item.feiyongxiang" :value="item.feiyongxiang"></el-option>
              </el-select>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_flex_end">
            <div class="revenbook-drawer-ul-but vue-font-PingFang-500 color_255" @click="addShouzhiFun">确定</div>
          </ul>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="选择店铺" :visible.sync="dialogVisible" width="30%">
      <el-table :data="dpList" style="width: 100%" :header-cell-style="headercellstyle" border height="60vh" tooltip-effect="dark" @selection-change="handleSelecshopChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="店铺名称"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">、
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
  components: { Pagination },
  data() {
    return {
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: 'rgba(245, 247, 250, 1)',
        color: 'rgba(51, 3, 0, 1)'
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        shopid: '',
        name:"",
      },
      value1: '',

      searchValue: '',

      activeName: 'census',
      tabsList: [{title: '统计', activeVal: 'census'}, {title: '日历', activeVal: 'calendar'}, {title: '明细', activeVal: 'details'}, {title: '记账模板', activeVal: 'keep'}],

      dataList: [],
      tableData: [],
      detailsData: [],
      keepData: [],

      strokeDrawer: false,
      tempObj: {
        feiyongbianma: '',
        yijileimu: '',
        erjileimu: '',
        feiyongxiang: '',
        isdanri: '1',
        date: '',
        zhichutype: '1',
        jine: '',
        desc: '',
        incomeradio: '',

        shopradio: '0',
        shopids: [],
        sterplate: false,
        mobanname: '',
      },
      options: [{ value: '选项1', label: '黄金糕' }, { value: '选项2', label: '双皮奶' }, { value: '选项3', label: '蚵仔煎' }, { value: '选项4', label: '龙须面' }, { value: '选项5', label: '北京烤鸭' }],
      allshouru: 0,
      allzhichu: 0,
      dpList: [],
      currentDate: new Date(), // 当前系统日期
      currentYear: new Date().getFullYear(), // 当前年份
      currentMonth: new Date().getMonth() + 1, // 当前月份（1-12）
      selectedDate: null, // 选中的日期
      view: 'month', // 默认月视图
      dateList: {},

      dialogVisible: false,


    };
  },

  computed: {
    // 生成当月所有日期（含上月/下月填充日期）
    monthDates() {
      const dates = [];
      const firstDay = new Date(this.currentYear, this.currentMonth - 1, 1); // 当月第一天
      const lastDay = new Date(this.currentYear, this.currentMonth, 0); // 当月最后一天
      const startDay = firstDay.getDay(); // 当月第一天是周几（0=周日）

      // 添加上月填充日期
      for (let i = startDay; i >= 1; i--) {
        const day = new Date(this.currentYear, this.currentMonth - 1, 1 - i);
        dates.push({
          day: day.getDate(),
          month: day.getMonth() + 1,
          year: day.getFullYear(),
        });
      }

      // 添加当月日期
      for (let i = 1; i <= lastDay.getDate(); i++) {
        const day = new Date(this.currentYear, this.currentMonth - 1, i);
        dates.push({
          day: i,
          month: this.currentMonth,
          year: this.currentYear,
        });
      }

      // 添加下月填充日期，保证共42天（6周）
      const remaining = 42 - dates.length;
      for (let i = 1; i <= remaining; i++) {
        const day = new Date(this.currentYear, this.currentMonth, i);
        dates.push({
          day: day.getDate(),
          month: day.getMonth() + 1,
          year: day.getFullYear(),
        });
      }

      return dates;
    },
  },

  created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    this.getdpListFun()
    this.shouzhiFun()
  },

  methods: {
    // 删除（原有方法）
    handleDelete(row) {
      this.$confirm("您确定删除么?", "警告！", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let url = this.$urls.delShouzhi;
        if(this.activeName == 'keep'){
          url = this.$urls.delShouzhiMoban;
        }
        const res = await this.$http.get(url, {id: row.row.id });
        console.log("----", res);
        if (res.errcode == 0) {
          DonMessage.success("删除成功");
          this.choose();
        } else {
          DonMessage.error("删除失败");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    choose(){
      console.log('this.listQuery',this.listQuery);
      this.listQuery.page = 1
      if(this.activeName === 'census' || this.activeName === 'details'){
        this.shouzhiFun()
      }
      if(this.activeName === 'calendar'){
        this.getRiqiFun()
      }
      if(this.activeName === 'keep'){
        this.shouzhiMobanFun()
      }
    },
    handleClick(row){
      if(this.activeName === row.activeVal) return
      this.activeName = row.activeVal
      this.listQuery.page = 1
      if(this.activeName === 'census' || this.activeName === 'details'){
        this.shouzhiFun()
      }
      if(this.activeName === 'calendar'){
        this.getRiqiFun()
      }
      if(this.activeName === 'keep'){
        this.shouzhiMobanFun()
      }
    },

    handleSelecshopChange(e){
      this.$set(this.tempObj, 'shopids', e)
    },

    handleSelectionChange(e){
      console.log(e, '10199343876')
    },
    getHetongListFun(){

    },

    async loginClick() {
      // if(!this.tempObj.username) return DonMessage.error(`请输入账号或联系客服获取账号`);
      // if(!this.tempObj.password) return DonMessage.error(`请输入密码`);
      this.$router.push({ path: "/main/level1/dashboard" });
    },


    async shouzhiFun(){
      const res = await this.$http.get(this.$urls.shouzhiList, this.listQuery);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.total = res.count
      if(this.activeName === 'census'){
        this.tableData = res.list
      }
      if(this.activeName === 'details'){
        this.detailsData = res.list
        this.allshouru = res.allshouru
        this.allzhichu = res.allzhichu
      }
      this.activeFun()
    },

    activeFun(){
      this.dataList = []
      if(this.activeName === 'census'){
        this.dataList = JSON.parse(JSON.stringify(this.tableData))
      }
      if(this.activeName === 'details'){
        this.dataList = JSON.parse(JSON.stringify(this.detailsData))
      }
      if(this.activeName === 'keep'){
        this.dataList = JSON.parse(JSON.stringify(this.keepData))
      }
    },


    // 店铺列表
    async getdpListFun() {
      const res = await this.$http.get(this.$urls.getshoplist, {
        page: 1,
        limit: 10000,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dpList = res.list;
      console.log("21312312");
    },

    async getRiqiFun(){
      const res = await this.$http.get(this.$urls.getRiqi, {
        year: this.currentYear,
        month: this.currentMonth,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dateList = res.dateList
    },

    async addShouzhiFun(){
      let shopids = []
      if(this.tempObj.shopids.length > 0){
        for(let item of this.tempObj.shopids){
          shopids.push(item.id)
        }
      }
      console.log(this.tempObj, '101010')
      const res = await this.$http.post(this.$urls.addShouzhi, {
        ...this.tempObj,
        sanjileimu: '',
        is_muban: this.tempObj.sterplate? '1' : '0',
        shopids: shopids.length > 0? shopids.join(',') : '',
        date: Number(this.tempObj.isdanri) === 1? this.timeFun(this.tempObj.date) : `${this.timeFun(this.tempObj.date[0])}-${this.timeFun(this.tempObj.date[1])}`,
        // feiyongxiang: '费用项'
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      DonMessage.success("操作成功");
      this.strokeDrawer = false
      this.shouzhiFun()
    },

    async shouzhiMobanFun(){
      const res = await this.$http.get(this.$urls.shouzhiMobanList, {
        ...this.listQuery,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      // DonMessage.success("操作成功");
      this.keepData = res.list
      this.activeFun()
    },

    timeFun(e){
      let year = this.currentDate.getFullYear()
      let month = this.currentDate.getMonth() + 1
      let day = this.currentDate.getDate()
      return year + "/" + month + "/" + day
    },



    currentChange(){
      this.currentYear = this.currentDate.getFullYear()
      this.currentMonth = this.currentDate.getMonth() + 1
      this.getRiqiFun()
    },
    currentmoon(){
      this.currentDate = new Date() // 当前系统日期
      this.currentYear = this.currentDate.getFullYear()
      this.currentMonth = this.currentDate.getMonth() + 1
      this.getRiqiFun()
    },
    isdanriChange(e){
      this.$set(this.tempObj, 'date', Number(e) === 1? '' : [])
    },

    // 日期格式化：转为“年/月/日”字符串
    formatDate(date) {
      return `${date.year}/${String(date.month).padStart(2, '0')}/${String(date.day).padStart(2, '0')}`;
    },
    // 判断日期是否有数据
    hasData(date) {
      const dateStr = this.formatDate(date);
      return this.dateList[dateStr] && this.dateList[dateStr].length > 0;
    },
    // 判断是否为今天
    isToday(date) {
      return (
        date.year === this.currentDate.getFullYear() &&
        date.month === this.currentDate.getMonth() + 1 &&
        date.day === this.currentDate.getDate()
      );
    },
    // 选择日期
    selectDate(date) {
      this.selectedDate = { ...date };
    },




  },
}
</script>

<style lang="scss" scoped>
  .revenbook{
    padding: 26px 22px;
  }

  .revenbook-tabs{
    .revenbook-tabs-boxs{
      gap: 73px;
      li{
       p{
        font-size: 26px;
       }
       div{
        width: 100%;
        height: 3px;
        background: #195CF8;
        border-radius: 2px;
        bottom: -12px;
        left: 0px;
       }
      }
      .active{
        color: rgba(25, 92, 248, 1);
      }
      .activenot{
        color: rgba(35, 35, 35, 1);
      }
    }
  }

  .revenbook-screen{
    padding: 19px 25px; background: rgba(245, 245, 245, 1); border-radius: 10px; margin: 22px 0px;
  }

  .revenbook-tabs-but{
    width: 131px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
  }

  .revenbook-drawer{
    padding: 0px 25px;
    .revenbook-drawer-ul{
      margin-top: 27px;
      li:nth-of-type(1){
        font-size: 18px;
        margin-bottom: 20px;
        span{
          color: rgba(255, 17, 17, 1);
        }
        p{
          color: rgba(35, 35, 35, 1);
        }
      }
      .revenbook-drawer-ul-radio{
        margin-bottom: 18px;
      }
      .revenbook-drawer-ul-boxs{
        background: rgba(245, 245, 245, 1); border-radius: 10px; padding: 10px;
        img{
          width: 22px; height: 22px; margin-right: 11px;
        }
        p{
          color: rgba(35, 35, 35, 1); font-size: 18px; line-height: 18px;
        }
      }
      .revenbook-drawer-ul-u-tr{
        background: rgba(244, 245, 249, 1); padding: 14px 39px; margin-top: 24px; border-radius: 10px;
        p{
          font-size: 18px; line-height: 18px; width: 45%; margin-right: 20px;
        }
      }
      .revenbook-drawer-ul-u-th{
        padding: 14px 39px;
        p{
          font-size: 18px; line-height: 18px; width: 45%; margin-right: 20px;
        }
      }
      .revenbook-drawer-ul-but{
        width: 131px; height: 54px; line-height: 54px; text-align: center; background: rgba(25, 92, 248, 1); border-radius: 10px;
      }
    }
  }
  .revenbook-details{
    line-height: 24px;
    margin-bottom: 19px;
    span:nth-of-type(2){
      color: rgba(5, 193, 0, 1);
      margin-right: 30px;
    }
    span:nth-of-type(4){
      color: rgba(255, 0, 0, 1);
    }
  }


  .revenbook-screen .el-input /deep/.el-input__inner {
    border: none !important;
    font-size: 18px;
  }
  .revenbook-drawer .el-input /deep/.el-input__inner {
    border: none !important;
    background: none !important;
    font-size: 18px;
  }
  .el-select /deep/.el-input__inner{
    border: none !important;
    font-size: 18px;
  }
  .top_bar_inp {
    width: 372px;
    height: 54px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin-right: 32px;
    padding: 0 11px;
    .top_bar_inp_img1 {
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
    .top_bar_inp_inp {
      width: 282px;
    }
  }
  .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        .shaixuan_item_tit {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #232323;
        }
        .shaixuan_item_sel {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }

  .shaixuan_item{
    .el-input /deep/.el-input__inner{
      border: none !important;
      text-align: right;
      font-size: 18px;
    }
    .el-input /deep/.el-input__prefix{
      display: none !important;
    }

    .el-select /deep/.el-input__inner{
      border: none !important;
      text-align: right;
      font-size: 18px;
    }
  }


  .date-list-app {
    display: flex;
    gap: 20px;
    margin: 0 auto;
    padding: 20px;
  }

.calendar-section {
  flex: 1;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
}

.calendar-header {
  width: 100%;
  margin-bottom: 10px;
}

.calendar-header button {
  padding: 4px 8px;
  cursor: pointer;
}

.week-days, .date-grid {
  display: flex;
  flex-wrap: wrap;
}

.week-days > div, .date-cell {
  width: 14.285%; /* 7列均分 */
  box-sizing: border-box;
  text-align: center;
  padding: 10px 0;
}

.week-days > div {
  background: #f5f7fa;
  font-weight: bold;
}

.date-cell {
  border: 1px solid #eee;
  min-height: 60px;
  cursor: pointer;
}

.date-cell.other-month {
  background: #f9f9f9;
  color: #ccc;
}

.date-cell.has-data {
  background: #e6f7ff;
}

.date-cell.today {
  color: #ffffff;
  background: #2f5496;
  font-weight: bold;
}

.date-number {
  display: block;
}

.data-section {
  flex: 1;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
}

.data-section ul {
  list-style: none;
  padding-left: 0;
}

.data-section li {
  padding: 5px 0;
  border-bottom: 1px dashed #ddd;
}

.data-section li:last-child {
  border-bottom: none;
}

.timeshoutype{
  color: rgba(71, 201, 177, 1);
}
.timezhitype{
  color: rgba(255, 109, 232, 1);
}
.shaixuan_btns {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  .shaixuan_btn1 {
    width: 132px;
    height: 55px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #999999;
    text-align: center;
    line-height: 55px;
  }
  .shaixuan_btn2 {
    margin-left: 25px;
    width: 131px;
    height: 54px;
    background: #195cf8;
    border-radius: 10px;
    text-align: center;
    line-height: 55px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/reven/reven_book/index.vue